import { CarCondition, FuelType, NumberCylinders, } from "../../../enum/cardDetailsForm";
export var filtersData = function (insurance, tl) {
    return [
        {
            label: insurance,
            name: tl("carDetails.insuranceType"),
            type: "label",
        },
    ];
};
export var getNumberCylindersOption = [
    { id: NumberCylinders.DOS, name: "2" },
    { id: NumberCylinders.TRES, name: "3" },
    { id: NumberCylinders.CUATRO, name: "4" },
    { id: NumberCylinders.CINCO, name: "5" },
    { id: NumberCylinders.SEIS, name: "6" },
    { id: NumberCylinders.OCHO, name: "8" },
    { id: NumberCylinders.DIEZ, name: "10" },
    { id: NumberCylinders.DOCE, name: "12" },
];
export var getFuelTypeOption = function (tl) { return [
    {
        id: FuelType.GASOLINE,
        name: tl("carDetails.fullType.gasolina"),
    },
    {
        id: FuelType.DIESEL,
        name: tl("carDetails.fullType.diesel"),
    },
    {
        id: FuelType.ELECTRIC,
        name: tl("carDetails.fullType.el\u00E9ctrico"),
    },
    {
        id: FuelType.GAS,
        name: tl("carDetails.fullType.gas"),
    },
]; };
export var carConditionOption = function (tl) { return [
    {
        id: CarCondition.NEW,
        name: tl("carDetails.carCondition.nuevo"),
    },
    {
        id: CarCondition.USED,
        name: tl("carDetails.carCondition.usado"),
    },
]; };
export var dataEditVehicleForm = {
    carDetails: null,
    year: "",
    carColor: null,
    chassisNumber: "",
    price: "",
    numberCylinders: null,
    fuelType: null,
    registrationNumber: "",
    carCondition: null,
    employeeNumber: "",
};
